import AdminTopNavLinks from '../../atoms/AdminTopNavLinks';
import logo from './images/olps_logo.png';
import MenuIcon from '@mui/icons-material/Menu';
import { getAdminInfo } from '../../../helper';
import { Link } from 'react-router-dom';

const AdminTopNav = () => {
  let menuState = 'menu';
  const adminInfo = getAdminInfo();

  const Menu = e => {
    let list = document?.querySelector('ul');
    if (menuState === 'menu') {
      openMenu(list);
    } else {
      closeMenu(list);
    }
  };

  const openMenu = list => {
    menuState = 'close';
    list.classList.add('top-[60px]');
    list.classList.add('opacity-100');
  };

  const closeMenu = list => {
    menuState = 'menu';
    list.classList.remove('top-[60px]');
    list.classList.remove('opacity-100');
  };

  if (adminInfo === null) return;

  return (
    <nav className=' bg-gradient-to-b from-primary-100 to-primary-200 lg:flex lg:items-center lg:justify-between'>
      <div className='flex items-center justify-between p-2'>
        <img src={logo} alt='OLPS Logo' className='mr-4 inline h-12' />
        <span className='text-md font-bold sm:text-2xl md:text-3xl'>
          <Link to='/manage'>
            <span className=''>Catechism Registration</span>
          </Link>
        </span>

        <span className='mx-2 block cursor-pointer lg:hidden'>
          <div className='' id='menuDiv'>
            <MenuIcon name='menu' onClick={Menu} />
          </div>
        </span>
      </div>

      <ul
        id='admin-nav-container'
        data-cy='admin-nav-container'
        className='absolute left-0 top-[-400px] z-40 w-full bg-white py-4 pl-7 shadow transition-all duration-300 ease-in lg:static lg:z-auto lg:flex lg:w-auto lg:items-center lg:bg-transparent lg:py-0 lg:pl-0 lg:opacity-100 lg:shadow-none'
      >
        <AdminTopNavLinks
          menuCallback={Menu}
          destination='/manage/students'
          endPage={false}
        >
          Students
        </AdminTopNavLinks>
        <AdminTopNavLinks
          menuCallback={Menu}
          destination='/manage/parents'
          endPage={false}
        >
          Parents
        </AdminTopNavLinks>
        <AdminTopNavLinks
          menuCallback={Menu}
          destination='/manage/classes'
          endPage={false}
        >
          Classes
        </AdminTopNavLinks>
        {Number(adminInfo['admin_level']) === 9 && (
          <>
            <AdminTopNavLinks
              menuCallback={Menu}
              destination='/manage/events'
              endPage={false}
            >
              Events
            </AdminTopNavLinks>
            <AdminTopNavLinks
              menuCallback={Menu}
              destination='/manage/homecats'
            >
              HomeCats
            </AdminTopNavLinks>
          </>
        )}
        <AdminTopNavLinks menuCallback={Menu} destination='/manage/settings'>
          Settings
        </AdminTopNavLinks>
        <AdminTopNavLinks menuCallback={Menu} destination='/logout'>
          Logout
        </AdminTopNavLinks>
      </ul>
    </nav>
  );
};

export default AdminTopNav;
